export default __webpack_public_path__ + "static/media/DOM-MAR-2024.5bcf0a38.png";